import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import { AccountContext } from "context/account";
import api from "services/api";
import toast from "react-hot-toast";
import JSZip from "jszip";
import FileSaver from "file-saver";

import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Tooltip from "@mui/material/Tooltip";

import AddResourceModal from "pages/online-resource/components/AddResourceModal";
import FlatDrawingDetailModal from "pages/online-resource/components/FlatDrawingDetailModal";

const FlatDrawingCard = ({ resource, handleRefresh = () => {}, handleClick, ...rest }) => {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [detailVisible, setDetailVisible] = useState(false);

  const account = useContext(AccountContext);
  const navigate = useNavigate();

  const handleDefaultDelete = async () => {
    if (!resource?.id) {
      return toast.error("Could not find the resource ID!");
    }
    try {
      await api.onlineResource.delete(resource.id);
    } catch (err) {
      console.log(err);
      toast.error("Delete resource failed!");
    }
  };

  const handleDownloadAll = () => {
    const resourceList = resource?.metadata?.resourceFiles || [];
    console.log(resource);

    const zip = new JSZip();
    const promises = []; //用于存储多个promise

    //resource files
    if (resourceList.length > 0) {
      for (let i = 0; i < resourceList.length; i++) {
        if (resourceList[i]?.url) {
          const promise = getFile(resourceList[i].url).then((res) => {
            const nameArr = resourceList[i]?.name.split("/");
            const fileName = nameArr[nameArr.length - 1];
            zip.file(fileName, res, { binary: true });
          });
          promises.push(promise);
        }
      }
    }

    if (resource?.img?.url) {
      const promise = getFile(resource?.img?.url).then((res) => {
        const fileName = resource?.img?.name || "sketch";
        zip.file(fileName, res, { binary: true });
      });
      promises.push(promise);
    }

    if (promises && promises.length > 0) {
      const toastId = toast.loading("Start downing resource files...");
      Promise.all(promises)
        .then(() => {
          zip
            .generateAsync({
              type: "blob",
              compression: "DEFLATE", // STORE：默认不压缩 DEFLATE：需要压缩
              compressionOptions: {
                level: 4, // 压缩等级1~9    1压缩速度最快，9最优压缩方式
              },
            })
            .then((res) => {
              toast.success("Download resource files started successfully!");
              FileSaver.saveAs(res, resource.title ? resource.title : "resource.zip");
            })
            .catch((err) => {
              toast.dismiss(toastId);
            });

          toast.dismiss(toastId);
        })
        .catch((err) => console.log("download failed!"));
    } else {
      toast.error("No available sketch files!");
    }
  };

  const getFile = (url) => {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return (
    <div>
      <div>
        <SuiBox
          onClick={(e) => {
            handleClick ? handleClick(e, resource) : setDetailVisible(true);
          }}
          sx={{
            cursor: "pointer",

            overflow: "hidden",
            position: "relative",
            display: "flex",
            minWidth: 0,
            width: "100%",
            height: 234,
            ...rest?.sx,
          }}
          className="hover-parent"
        >
          <ImageCardWrapper
            data={resource?.img}
            height={234}
            width={"100%"}
            draggable={false}
            resizeType="m_lfit"
            className="object-fit"
            {...rest}
          />
          <SuiBox className="overlay">
            <SuiBox display="flex" alignItems="center" gap={1}>
              <SuiTypography
                variant="body1"
                textTransform="none"
                color="white"
                sx={{
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {resource?.title}
              </SuiTypography>{" "}
            </SuiBox>
          </SuiBox>
        </SuiBox>
      </div>

      <SuiBox sx={{ my: 0.5, px: 1 }}>
        <SuiBox display="flex" justifyContent="space-between" alignItems="center">
          <SuiBox>
            <SuiTypography
              variant="body1"
              textTransform="none"
              color="dark"
              sx={{
                fontWeight: "bold",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
              }}
            >
              {resource?.title}
            </SuiTypography>
          </SuiBox>
          <SuiBox display="flex" alignItems="center" gap={0.5}>
            <Tooltip title="Download">
              <DownloadIcon
                fontSize={"small"}
                color="dark"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  handleDownloadAll();
                }}
              />
            </Tooltip>
            {account.role == "admin" ? (
              <>
                <Tooltip title="Edit">
                  <EditIcon
                    fontSize={"small"}
                    color="dark"
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      setEditVisible(true);
                    }}
                  />
                </Tooltip>

                <Tooltip title="Remove">
                  <DeleteForeverIcon
                    fontSize={"small"}
                    color="error"
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      setDeleteVisible(true);
                    }}
                  />
                </Tooltip>
              </>
            ) : null}
          </SuiBox>
        </SuiBox>
      </SuiBox>

      {deleteVisible && resource?.id ? (
        <Prompt
          heading="Delete Resource"
          text={`Are you sure you want to delete: ${resource.title}`}
          visible={deleteVisible}
          okText="Delete"
          okColor="error"
          handleOk={() => handleDefaultDelete()}
          handleClose={() => setDeleteVisible(false)}
        />
      ) : null}
      {editVisible ? (
        <AddResourceModal
          visible={editVisible}
          handleClose={() => setEditVisible(false)}
          type={"flat_sketch"}
          isEdit={true}
          resource={resource}
          handleRefresh={handleRefresh}
        />
      ) : null}
      {detailVisible ? (
        <FlatDrawingDetailModal
          visible={detailVisible}
          handleClose={() => setDetailVisible(false)}
          detail={resource}
          handleDownloadAll={handleDownloadAll}
        />
      ) : null}
    </div>
  );
};
export default FlatDrawingCard;
